import { render } from "./HomePage.vue?vue&type=template&id=792b0504"
const script = {}
script.render = render

export default script